import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useQuery } from "react-query";
import { Icon } from '@iconify/react';
import plusFill from '@iconify/icons-eva/plus-fill';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Card,
  Stack,
  Button,
  Container,
  Typography,
  TableContainer,
} from '@mui/material';
// components
import Page from 'components/Page';
import Scrollbar from 'components/Scrollbar';
import TableList from 'components/tableList';
import ModalConfirmation from 'components/modalConfirmation';
import { UserMoreMenu } from 'components/_dashboard/user';

// services
import { getApps, deleteApp } from "services/adminApp.service";

export default function App() {
  const history = useHistory();
  const [deleteId, setDeletedId] = useState("");
  const [show, setShow] = useState(false);
  const { isSuccess, data } = useQuery(["apps"], getApps);
 
  const [apps, setApps] = useState([]);

  useEffect(() => {
    if (isSuccess && data) {
      setApps(data);
    }
  }, [isSuccess, data]);

  const columnApps = useMemo(() => {
    return [
      {
        name: "#",
        selector: (row, index) => index + 1,
        width: "80px"
      },
      {
        name: "Name",
        selector: row => row.name,
        sortable: true
      },
      {
        name: "Code",
        selector: row => row.code,
        sortable: true
      },
      {
        name: "Action",
        button: true,
        cell: row => (
          <UserMoreMenu 
            onEdit={() => history.push(`/admin/app/edit/${row.uId}`)}
            onDelete={() => {
              setDeletedId(row.uId);
              setShow(true);
            }}
          />
        )
      }
    ]
  }, [history]);

  const sourceApps = useMemo(() => {
    return apps.map((app, index) => (
      {
        key: index,
        uId: app.uId,
        _id: app._id,
        name: app.name,
        code: app.code,
      }
    ));
  }, [apps]);

  const handleDelete = useCallback(async () => {
    const res = await deleteApp({deleteId});
    if (res) {
      setApps(apps.filter(x => x.uId !== deleteId));
    }

    setShow(false);
  }, [deleteId, apps]);


  return (
    <Page title="App">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            App
          </Typography>
          <Button
            variant="contained"
            component={RouterLink}
            to="/admin/app/create"
            startIcon={<Icon icon={plusFill} />}
          >
            New App
          </Button>
        </Stack>

        <Card>
          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <TableList
                columns={columnApps}
                data={sourceApps}
                isFilter={true}
              />
            </TableContainer>
          </Scrollbar>
        </Card>

        <ModalConfirmation 
          open={show}
          handleClose={() => setShow(false)}
          handleOk={() => handleDelete()}
        />
      </Container>
    </Page>
  );
}
